import React from "react";
import { Box, Container, Paper, Typography, Button, Stack } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation, useNavigate } from "react-router-dom";

const NoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const error = searchParams.get("error");

  const getTitle = () => {
    if (error === "auto-login-failed") return "Automatic sign-in failed";
    if (error === "auto-login-error") return "Automatic sign-in error";
    return "Something went wrong";
  };

  const getMessage = () => {
    if (error === "auto-login-failed") {
      return "We couldn't sign you in automatically. The link may be invalid or expired.";
    }
    if (error === "auto-login-error") {
      return "An unexpected error occurred during automatic sign-in. Please try again.";
    }
    return "We hit a snag while processing your request. Please try again in a moment.";
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f4f6fa", display: "flex", alignItems: "center" }}>
      <Container maxWidth="sm">
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "rgba(25,118,210,0.08)", mr: 2 }}>
              <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: 28 }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {getTitle()}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {getMessage()}
          </Typography>

        
        </Paper>
      </Container>
    </Box>
  );
};

export default NoPage;


